import React from 'react';

const BlogCard = ({ item }) => {
    const API_BASE = 'https://api.liber.am';
    const goldColor = '#c5a059';

    // Ֆունկցիա՝ HTML թեգերը և &nbsp; կոդերը մաքրելու համար
    const cleanText = (html) => {
        if (!html) return "";
        const doc = new DOMParser().parseFromString(html, 'text/html');
        let text = doc.body.textContent || "";
        // Մաքրում ենք ավելորդ բացատները
        return text.trim();
    };

    const displayDescription = cleanText(item.description || item.content);

    return (
        <div className="blog-card" style={{
            background: 'rgba(255, 255, 255, 0.02)',
            borderRadius: '20px',
            border: '1px solid rgba(255, 255, 255, 0.05)',
            overflow: 'hidden',
            transition: '0.4s',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            cursor: 'pointer'
        }}>
            {/* 1. Նկարը - Ավելացրինք Alt տեքստի SEO-ն */}
            <div style={{ height: '220px', overflow: 'hidden', position: 'relative' }}>
                <img 
                    src={`${API_BASE}${item.image}`} 
                    alt={item.title || "Liber Service"}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} 
                    loading="lazy"
                    decoding="async"
                    onError={(e) => { 
                        e.target.onerror = null; 
                        e.target.src = 'https://via.placeholder.com/400x250?text=Liber+Logistics'; 
                    }} 
                />
            </div>

            {/* Տեքստային հատված */}
            <div style={{ 
                padding: '25px', 
                display: 'flex', 
                flexDirection: 'column', 
                flexGrow: 1 
            }}>
                {/* 2. Կատեգորիա */}
                <h4 style={{ 
                    color: goldColor, 
                    fontSize: '11px', 
                    marginBottom: '12px', 
                    letterSpacing: '2px',
                    fontWeight: '600'
                }}>
                    {item.category ? item.category.toUpperCase() : 'ԼՈԳԻՍՏԻԿԱ'}
                </h4>

                {/* 3. Վերնագիր - Սահմանափակում ենք տողերը, որ բոյերը չփախնեն */}
                <h3 style={{ 
                    color: '#fff', 
                    fontSize: '19px', 
                    marginBottom: '15px', 
                    lineHeight: '1.3',
                    display: '-webkit-box',
                    WebkitLineClamp: '2',
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    minHeight: '50px' // Որ եթե 1 տող լինի, էլի նույն բոյը մնա
                }}>
                    {item.title}
                </h3>

                {/* 4. Նկարագրություն - Մաքրված HTML-ից */}
                <p style={{ 
                    color: '#a0a0a0', 
                    fontSize: '14px', 
                    lineHeight: '1.6',
                    display: '-webkit-box',
                    WebkitLineClamp: '3', // Մաքսիմում 3 տող
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    flexGrow: 1
                }}>
                    {displayDescription}
                </p>
                
                {/* 5. Կոճակ */}
                <div style={{ 
                    marginTop: '20px', 
                    color: goldColor, 
                    fontWeight: '600', 
                    fontSize: '13px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                    ԿԱՐԴԱԼ ԱՎԵԼԻՆ <span style={{ fontSize: '18px' }}>→</span>
                </div>
            </div>
        </div>
    );
};

export default BlogCard;